import { memo, useMemo } from 'react';
// Components
import { IconButton } from '@effizency/efz-design-system';
import { SideMenuColapse, SideMenuExpand } from '@effizency/efz-design-system';
import { Link } from 'react-router-dom';

// Images / Icons
import { ReactComponent as PoweredLogo } from 'assets/@efz/icons/logo-powered.svg';
import { ReactComponent as PlatformLogo } from 'assets/images/logos/svg/edp-logo.svg';

import { StyledSidebarContent } from 'components/@efz/Sidebar/StylesSidebar';

import { BASENAME_URL } from 'constants/settings';
// Constants
import { SIDEBAR_ENTRIES_CONFIG } from 'constants/sidebar';

// Contexts/Stores
import { useSidebarStore } from 'stores/sidebar';

import SidebarSection from './Section';
import SidebarUserCard from './UserCard';

const SidebarContent = ({ headerVisible }: { headerVisible: boolean }) => {
    const {
        sidebarOpen,
        actions: { setSidebarOpen },
    } = useSidebarStore();

    const IconAndOpenHandler = useMemo(
        () => (
            <>
                {sidebarOpen && (
                    <Link to={`${BASENAME_URL}app/opportunities`}>
                        <PlatformLogo width={90} height={34} />
                    </Link>
                )}
                <IconButton variant="tertiary" size="xs" onClick={() => setSidebarOpen(!sidebarOpen)} dataTestId="sidebar-open-btn">
                    {sidebarOpen ?
                        <SideMenuColapse size="xs" variant="tertiary" iconBtn />
                    :   <SideMenuExpand size="xs" variant="tertiary" iconBtn />}
                </IconButton>
            </>
        ),
        [sidebarOpen, setSidebarOpen]
    );

    return (
        <StyledSidebarContent $open={sidebarOpen}>
            <div className="sidebar-content-top">
                {!headerVisible && <div className="icon-and-handler">{IconAndOpenHandler}</div>}
                <div className="sidebar-divider" />
                {SIDEBAR_ENTRIES_CONFIG.filter((entry) => entry.visible).map((entry, index) => (
                    <SidebarSection key={`sidebar-entry-${index}`} {...entry} />
                ))}
            </div>
            <SidebarUserCard />
            <PoweredLogo className="powered-logo" />
        </StyledSidebarContent>
    );
};

export default memo(SidebarContent);
